<template>
  <component
    :is="href ? 'a' : 'button'"
    :disabled="loading"
    @click="evt => $emit('click', evt)"
    :class="buttonClasses"
    :href="href"
    :target="href ? '_blank' : ''"
    :type="href ? undefined : (submit ? 'submit' : 'button')"
  >
    <div :class="`btn__content ${loading ? 'transparent' : ''}`">
      <slot></slot>
      <spinner :active="loading" color="white" size="24px" borderWidth="3px"/>
    </div>
  </component>
</template>

<script>
export default {
  name: 'btn',
  props: {
    icon: Boolean,
    flat: Boolean,
    loading: Boolean,
    small: Boolean,
    medium: Boolean,
    large: Boolean,
    href: String,
    submit: Boolean,
    outlined: Boolean,
    color: {
      type: String,
      default: 'pink',
      validator: s => ['pink', 'purple', 'orange', 'white'].includes(s)
    }
  },
  computed: {
    buttonClasses() {
      let classes = ['btn']
      if (!this.outlined) {
        classes.push(`btn--${this.color}`)
      }
      if (this.small) {
        classes.push('btn--small')
      } else if (this.medium) {
        classes.push('btn--medium')
      } else if (this.large) {
        classes.push('btn--large')
      }
      if (this.icon) {
        classes.push('icon')
      } else if (this.flat) {
        classes.push('flat')
      } else if (this.outlined) {
        classes.push('outlined')
      } else {
        classes.push('common')
      }
      return classes.join(' ')
    }
  }
}
</script>

<style lang="scss">
.btn {
  margin-top: 0;
  margin-bottom: 0;
  display: block;
  appearance: none;
  background: transparent;
  border: none;
  padding: 0;
  outline: none;
  cursor: pointer;
  outline: 0;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  transition: all 100ms;
  &:active {
    appearance: none;
  }
  &--pink:not(.icon) {
    background: #A217AB;
  }
  &--pink:not(.icon) {
    background: #A217AB;
  }
  &--purple:not(.icon) {
    background:  #A217AB;
    &:hover {
      background: #CE3ED1;
    }
  }
  &--orange:not(.icon) {
    background: #FFAC00;
  }
  &--green:not(.icon) {
    background: #4C91FF;
  }
  &--white:not(.icon) {
    background: #FFFFFF;
    color: #A217AB !important;
  }
  &__decoration {
    display: none;
  }

  &:disabled {
    opacity: 0.3;
  }

  &.common, &.flat, &.outlined {
    border-radius: 100px;
    padding: 0.9rem;
    &.btn--orange {
      box-shadow: 0px 8px 24px rgba(255, 119, 76, 0.4);
    }
    &.btn--purple {
      box-shadow: 5px 5px 10px rgba(141, 98, 255, 0.3);
    }
    .btn__decoration {
      display: block;
      position: absolute;
      width: 1em;
      height: 0.8em;
      top: 2px;
      right: 10px;
      background: {
        repeat: no-repeat;
        image: url('~@/assets/button-detail.svg');
        size: contain;
        position: 0 0;
      };
    }
  }
  &.common {
    .btn__decoration {
      right: 18px;
    }
  }
  &:not(.icon) {
    text-align: center;
    position: relative;
    font-size: 1.2rem;
    color: white;
    .btn__content {
      display: inline-flex;
      justify-content: center;
      font-weight: 900;
      &.transparent {
        color: transparent;
      }
      & > .spinner {
        position: absolute;
        top: calc(50% - 12px);
        left: calc(50% - 12px);
      }
    }
  }
  &.outlined {
    text-transform: capitalize;
    color: #8D8992;
    border: 2px solid #8D8992;
    background-color: transparent;
    margin-bottom: 8px;
    .btn__decoration {
      display: none;
    }
  }
  &.flat {
    height: inherit;
    margin-bottom: 8px;
    &:hover {
      background: #CE3ED1;
    }
    &:active {
      background: #830486
    }
    @media screen and (max-width: 567px) {
      box-shadow: 0px 8px 24px rgba(123, 77, 255, 0.2);
    }
  }
  &__content {
    display: flex;
    flex-direction: column;
    width: inherit;
    height: inherit;
    & > .subtitle {
      white-space: pre;
      text-transform: lowercase;
      font-weight: normal;
      margin-top: 4px;
      transition: opacity .2s, margin-top .2s;
      transition-timing-function: ease-in-out;
      &--hidden {
        margin-top: -20px;
        opacity: 0;
      }
    }
  }
  &--small {
    width: 24px;
    height: 24px;
  }
  &--medium {
    width: 30px;
    height: 30px;
  }
  &--large {
    width: 40px;
    height: 40px;
  }
  @media screen and (max-width: 1024px) {
    &--small {
      width: 20px;
      height: 20px;
    }
    &--medium {
      width: 26px;
      height: 26px;
    }
    &--large {
      width: 30px;
      height: 30px;
    }
  }
  img {
    width: inherit;
    height: inherit;
  }
}
</style>
